import React, {
  useEffect,useMemo,useRef,useState
}
 from 'react';
import {getExtractionRuntime} from './extractionRuntime';

// Contract sections supported by the structured extraction payload.
const TABS=['Overview','Agreement','CLINs','POPs','AC','PLCat','WD','JSON'];
const LOGO_URL=`${process.env.PUBLIC_URL||''}/atlas-compass-dark.png`;
const CONFIG= {
  CLINs: {
    code:'CLIN',columns:['Type__c','Status_1__c','Apttus_Description__c','CLIN_Number__c','Period_of_Performance__c','Funded_Amount__c','Contract_Value__c'],sort:'CLIN_Number__c'
  },POPs: {
    code:'PoP',columns:['Status__c','Description__c','Period__c','SEQ__c','Period_of_Performance_Start__c','Period_of_Performance_End__c','Contract_Value__c'],sort:'Period_of_Performance_Start__c'
  },AC: {
    code:'AC',columns:['FARDFAR_Number__c','Clause_Title__c','Effective_Date__c','Flow_Down_Clause__c','Description__c'],sort:'FARDFAR_Number__c'
  },PLCat: {
    code:'PLCat',columns:['PLC_CLIN_Number__c','PLC_Name__c','Party__c','Labor_Type__c','Work_Location__c','Bill_Rate__c','Hours_QTY__c','Labor_Ceiling__c'],sort:'PLC_CLIN_Number__c'
  },WD: {
    code:'WD',columns:['WD_Number__c','WD_Revision_Number__c','WD_Revision_Date__c','State__c','CBA_Number__c','Description__c'],sort:'WD_Number__c'
  }
};
const display=v=>v==null?'':typeof v==='object'?JSON.stringify(v):String(v);
const statusLabel=status=>({done:'Complete',queued:'Queued',processing:'Processing',uploading:'Uploading',error:'Attention',failed:'Attention',cancelled:'Cancelled'}[status]||status||'Unknown');
const sort=(items,key)=>[...items].sort((a,b)=>String(a?.[key]??'').localeCompare(String(b?.[key]??''),undefined, {
  numeric:true
}
));
const EMPTY_EDITOR_METADATA={
  picklists:{},
  boolean_fields:{},
  date_fields:[]
};
const clonePayload=value=>value==null?value:JSON.parse(JSON.stringify(value));

const resolvePicklistValue=(options,currentValue)=> {
  const current=display(currentValue);
  const selected=options.find(option=>
    String(option.value)===current||option.label===current
  );

  return selected?String(selected.value):current;
};

function ExpandableTextarea({
  fieldName,
  value,
  onChange,
  onExpand,
  readOnly=false
}) {
  const textareaRef=useRef(null);
  const[requiresScroll,setRequiresScroll]=useState(false);

  useEffect(()=> {
    const checkOverflow=()=> {
      const textarea=textareaRef.current;
      if(!textarea)return;

      setRequiresScroll(textarea.scrollHeight>textarea.clientHeight+1)
    };

    checkOverflow();
    window.addEventListener('resize',checkOverflow);
    return()=>window.removeEventListener('resize',checkOverflow)
  },[value]);

  return <>
    <div className="field-header-row">
      <label className="field-label">{fieldName}</label>
      {requiresScroll&&<button
        type="button"
        className="field-expand-btn"
        onClick={onExpand}
        aria-label={`Expand ${fieldName}`}
        title="Expand field"
      >
        ↗
      </button>}
    </div>
    <textarea
      ref={textareaRef}
      className="field-textarea"
      value={value}
      onChange={onChange}
      readOnly={readOnly}
      rows="2"
    />
  </>;
}
function Side( {
  username,
  onLogout,
  onNavigate,
  canViewPrompts=false
}
) {
  return <aside className="sidebar"><div className="brand"><img src={LOGO_URL} alt="ATLAS"/></div>
  <nav>
    <button
      className="active"
      onClick={()=>onNavigate('Jobs')}
    >
      <span>▣</span>
      Jobs
    </button>

    {canViewPrompts&&(
      <button onClick={()=>onNavigate('Prompts')}>
        <span>▤</span>
        Prompts
      </button>
    )}

    <button onClick={()=>onNavigate('Reports')}>
      <span>▥</span>
      Reports
    </button>
  </nav>
  <div className="sidebar-bottom"><div className="secure"><span>◆</span><div><b>Secure workspace</b><small>Contract ingestion</small></div></div><div className="user-card"><i> {
    (username||'AD').slice(0,2).toUpperCase()
  }
  </i><div><b> {
    username||'Administrator'
  }
  </b></div> {
    onLogout&&<button onClick= {
      onLogout
    }
    >↪</button>
  }
  </div></div></aside>
}
export default function ExtractedValuesPage( {
  jobId,
  jobSummary,
  onBack,
  username,
  onLogout,
  onNavigate,
  canEdit=false,
  canViewPrompts=false
}
) {
   const[tab,setTab]=useState('Overview'),[page,setPage]=useState(0),[job,setJob]=useState(null),[savedStructured,setSavedStructured]=useState(null),[message,setMessage]=useState('Loading extracted values…'),[docMode,setDocMode]=useState('document'),[saveStatus,setSaveStatus]=useState(''),[editorMetadata,setEditorMetadata]=useState(EMPTY_EDITOR_METADATA),[expandedField,setExpandedField]=useState(null);
   const [documentZoom, setDocumentZoom] = useState(100);

   useEffect(() => {
     setDocumentZoom(100);
   }, [jobId]);
   useEffect(()=> {
    let cancelled=false;(async()=> {
      try {
        const[jobResponse,metadataResponse]=await Promise.all([
          fetch(`/api/job/${jobId}`,{credentials:'same-origin'}),
          fetch('/api/metadata/extraction-fields',{credentials:'same-origin'})
        ]);
        const raw=await jobResponse.text();let data= {
        };try {
          data=raw?JSON.parse(raw): {
          }
        }
        catch {
          throw new Error(`Invalid server response (${jobResponse.status}).`)
        }
        if(!jobResponse.ok)throw new Error(data.error||data.detail||'Could not load job.');if(data.status!=='done')throw new Error(`This job is not complete. Current status: ${data.status}.`);if(!data.structured)throw new Error('This job does not contain a structured payload.');if(!cancelled) {
          let metadata=EMPTY_EDITOR_METADATA;
          if(metadataResponse.ok)metadata=await metadataResponse.json();
          setEditorMetadata(metadata);
          setSavedStructured(clonePayload(data.structured));
          setJob(data);setMessage('')
        }
      }
      catch(e) {
        if(!cancelled)setMessage(e.message)
      }
    }
    )();return()=> {
      cancelled=true
    }
  },[jobId]);
  useEffect(()=> {
    if(!expandedField)return undefined;

    const closeOnEscape=event=> {
      if(event.key==='Escape')setExpandedField(null)
    };

    document.addEventListener('keydown',closeOnEscape);
    return()=>document.removeEventListener('keydown',closeOnEscape)
  },[expandedField]);
   const records=useMemo(()=>Array.isArray(job?.structured?.records)?job.structured.records:[],[job]);
  const agreement=useMemo(()=>records.find(r=>r.Object__c==='AG')||null,[records]);
  const config=CONFIG[tab];
  const sectionRecords=useMemo(()=>config?sort(records.filter(r=>r.Object__c===config.code),config.sort):[],[records,config]);
  const pageCount=Math.max(1,Math.ceil(sectionRecords.length/10));
  const visible=sectionRecords.slice(page*10,page*10+10);
  const fields=useMemo(()=>agreement?Object.entries(agreement).filter(([k])=>!['attributes','Object__c','Name','NW_Id__c','SEQ__c'].includes(k)):[],[agreement]);
  const fileName=job?.original_filename||job?.saved_name||'Completed contract';
  const progress=job?.status==='done'?100:job?.pages_rendered?Math.min(90,25+(job?.pages_classified||0)*5):job?.status==='queued'?10:0;
  const runtime=getExtractionRuntime(jobSummary||job)||{label:'Not available',tone:''};
  const updateRecord=(target,fieldName,value)=> {
    if(!canEdit) {
      return;
    }
    const isDateField=(
      editorMetadata.date_fields||[]
    ).includes(fieldName);
  
    const normalizedValue=(
      isDateField&&
      typeof value==='string'&&
      value.trim()===''
    )
      ?null
      :value;
  
    setJob(current=>({
      ...current,
      structured:{
        ...current.structured,
        records:current.structured.records.map(
          record=>record===target
            ?{
                ...record,
                [fieldName]:normalizedValue
              }
            :record
        )
      }
    }));
  
    setSaveStatus('Unsaved changes');
  };
  const fieldEditor=(record,fieldName,value,tableField=false)=> {
    const objectCode=record?.Object__c;
    const picklistOptions=editorMetadata.picklists?.[objectCode]?.[fieldName]||[];
    const booleanField=
      typeof value==='boolean'||
      (editorMetadata.boolean_fields?.[objectCode]||[]).includes(fieldName);
    const selectClass=tableField?'table-value-select':'field-select';
    const withFieldHeader=control=>tableField?control:<>
      <div className="field-header-row">
        <label className="field-label">{fieldName}</label>
      </div>
      {control}
    </>;

    if(picklistOptions.length) {
      const selectedValue=resolvePicklistValue(picklistOptions,value);
      const selectedIsConfigured=picklistOptions.some(
        option=>String(option.value)===selectedValue
      );

      return withFieldHeader(<select
        className={selectClass}
        value={selectedValue}
        disabled={!canEdit}
        onChange={event=>updateRecord(record,fieldName,event.target.value)}
      >
        <option value="">Select a value</option>
        {!selectedIsConfigured&&selectedValue&&
          <option value={selectedValue}>{selectedValue} (current value)</option>
        }
        {picklistOptions.map(option=><option
          key={`${option.label}-${option.value}`}
          value={option.value}
        >
          {option.label}
        </option>)}
      </select>);
    }

    if(booleanField) {
      const selectedValue=value==null?'':String(value).toLowerCase();

      return withFieldHeader(<select
        className={selectClass}
        value={selectedValue}
        disabled={!canEdit}
        onChange={event=>updateRecord(
          record,
          fieldName,
          event.target.value===''?null:event.target.value==='true'
        )}
      >
        <option value="">Select a value</option>
        <option value="true">True</option>
        <option value="false">False</option>
      </select>);
    }

    if(tableField) {
      return <input
        className="table-value-input"
        value={display(value)}
        readOnly={!canEdit}
        onChange={event=>updateRecord(record,fieldName,event.target.value)}
      />;
    }

    return <ExpandableTextarea
      fieldName={fieldName}
      value={display(value)}
      readOnly={!canEdit}
      onChange={event=>updateRecord(record,fieldName,event.target.value)}
      onExpand={()=>setExpandedField(fieldName)}
    />;
  };
  const saveChanges=async()=> {
    if(!canEdit) {
      return false;
    }
    try {
      setSaveStatus('Saving…');
      const draftStructured=clonePayload(job.structured);
      const response=await fetch(`/api/jobs/${jobId}/structured`,{
        method:'PUT',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({structured:draftStructured})
      });
      const data=await response.json();
      if(!response.ok)throw new Error(data.error||'Could not save changes.');
      setSavedStructured(clonePayload(data.structured??draftStructured));
      setSaveStatus('Changes saved');
      return true;
    }
    catch(error) {
      setSaveStatus(error.message);
      return false;
    }
  };
  const sendToConga=async()=> {
    if(!canEdit) {
      return;
    }
    if(saveStatus==='Unsaved changes') {
      const saved=await saveChanges();
      if(!saved)return;
    }
    try {
      setSaveStatus('Sending to Conga…');
      const response=await fetch(`/api/jobs/${jobId}/send-to-conga`,{
        method:'POST',
        credentials:'same-origin'
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.error ||
          data.detail ||
          'Could not send to Conga.'
        );
      }

      if (data.job) {
        setJob(data.job);

        if (data.job.structured) {
          setSavedStructured(
            clonePayload(data.job.structured)
          );
        }
      } else {
        // Supports an older backend during deployment.
        setJob(currentJob =>
          currentJob
            ? {
                ...currentJob,
                conga_send_status: 'sent'
              }
            : currentJob
        );
      }

      setSaveStatus('Sent to Conga');
    }
    catch(error) {
      setSaveStatus(error.message);
    }
  };
  const savedName=job?.saved_name;
  const documentPageCount=Math.max(1,job?.pages_rendered||job?.document?.page_count||1);
  const documentPages=Array.from( {
    length:documentPageCount
  },(_,index)=>`/pdf2img/${encodeURIComponent(savedName)}/page-${String(index+1).padStart(4,'0')}.png`);
   const dataView=()=> {
    if(message)return <div className="page-message"> {
      message
    }
    </div>;
    if(tab==='JSON')return <pre className="json-viewer"> {
      JSON.stringify(savedStructured??job,null,2)
    }
    </pre>;
    if(['Overview','Agreement'].includes(tab))return <div className="agreement-fields"> {
      !agreement&&<div className="page-message">No Agreement values were found.</div>
    } {
      fields.map(([name,value])=><div className="agreement-field-group" key= {
        name
      }
      >{fieldEditor(agreement,name,value)}</div>)
    }
    </div>;
    return <><div className="pagination-bar"><span className="section-count"> {
      sectionRecords.length
    }
     extracted records</span><div className="pagination-controls"><button className="pagination-btn" disabled= {
      !page
    }
     onClick= {
      ()=>setPage(x=>x-1)
    }
    >Previous</button><span>Page {
      page+1
    }
     of {
      pageCount
    }
    </span><button className="pagination-btn" disabled= {
      page>=pageCount-1
    }
     onClick= {
      ()=>setPage(x=>x+1)
    }
    >Next</button></div></div><div className="section-table-wrapper"><table className="section-table"><thead><tr><th>#</th> {
      config.columns.map(c=><th key= {
        c
      }
      > {
        c
      }
      </th>)
    }
    </tr></thead><tbody> {
      !visible.length&&<tr><td colSpan= {
        config.columns.length+1
      }
      >No items available.</td></tr>
    } {
      visible.map((record,i)=><tr key= {
        record.attributes?.referenceId||i
      }
      ><td> {
        page*10+i+1
      }
      </td> {
        config.columns.map(c=><td key= {
          c
        }
        >{fieldEditor(record,c,record[c],true)}</td>)
      }
      </tr>)
    }
    </tbody></table></div></>
  };
   return <div className="app-shell review-page"><Side username= {
    username
  }
   onLogout= {
    onLogout
  }
   onNavigate= {
    onNavigate
  }
   canViewPrompts= {
    canViewPrompts
  }
  /><main className="content"><header className="review-header"><button className="back-btn" onClick= {
    onBack
  }
  >← All jobs</button><div className="review-title"><div><h1> {
    fileName
  }
  </h1><p>Job {
    jobId
  }
   · Complete · Ready for validation</p></div><div className="review-save-actions"><small> {
    saveStatus
  }
  </small>
    <button
    className="primary-btn"
    disabled={
      !canEdit
      || !job
      || saveStatus==='Saving…'
    }
    onClick={
      canEdit
        ? saveChanges
        : undefined
    }
  >
    Save changes
  </button>
  <button
    className="conga-btn"
    disabled={
      !canEdit
      || !job
      || saveStatus==='Saving…'
      || saveStatus==='Sending to Conga…'
    }
    onClick={
      canEdit
        ? sendToConga
        : undefined
    }
  >
    Send to Conga
  </button>
  </div></div><div className="review-tabs"> {
    TABS.map(name=><button key= {
      name
    }
     className= {
      tab===name?'active':''
    }
     onClick= {
      ()=> {
        setTab(name);setPage(0);setExpandedField(null)
      }
    }
    > {
      name
    }
    </button>)
  }
    </div></header>

  <div className={`review-workspace ${
    tab === 'Overview' ? 'overview-document-mode' : ''
  }`}>
    <section className="document-pane">
      <div className="doc-tools">
        <button
          className="secondary-btn"
          onClick={() => setDocMode(
            docMode === 'document' ? 'json' : 'document'
          )}
        >
          {docMode === 'document'
            ? '▤ Document'
            : '{ } Raw JSON'}
        </button>

        {docMode === 'document' && (
          <div className="document-zoom-controls">
            <button
              className="secondary-btn"
              aria-label="Zoom out"
              disabled={documentZoom <= 50}
              onClick={() => setDocumentZoom(
                zoom => Math.max(50, zoom - 10)
              )}
            >
              −
            </button>

            <span>{documentZoom}%</span>

            <button
              className="secondary-btn"
              aria-label="Zoom in"
              disabled={documentZoom >= 250}
              onClick={() => setDocumentZoom(
                zoom => Math.min(250, zoom + 10)
              )}
            >
              +
            </button>

            <button
              className="secondary-btn"
              onClick={() => setDocumentZoom(100)}
            >
              Reset
            </button>
          </div>
        )}

        <span>
          {`All ${documentPageCount} pages · scroll to review`}
        </span>
      </div>

      {docMode === 'document' ? (
        <div className="full-document-scroll">
          {savedName ? (
            <div className="document-pages">
              {documentPages.map((source, index) => (
                <figure
                  className="document-page"
                  key={source}
                  style={{ width: `${documentZoom}%` }}
                >
                  <img
                    src={source}
                    alt={`Document page ${
                      index + 1
                    } of ${documentPageCount}`}
                    loading="lazy"
                  />

                  <figcaption>
                    Page {index + 1} of {documentPageCount}
                  </figcaption>
                </figure>
              ))}
            </div>
          ) : (
            <div className="document-unavailable">
              The rendered document pages are not available
              for this record.
            </div>
          )}
        </div>
      ) : (
        <pre className="json-viewer">
          {JSON.stringify(savedStructured ?? job, null, 2)}
        </pre>
      )}
    </section> {
    <aside className="extract-pane"><div className="extract-summary"><div><span className="kicker">AI EXTRACTION</span><h2> {
    tab
  }
  </h2></div><span className="confidence-chip">✓ Structured output</span></div> {
    tab==='Overview'&&<div className="job-overview-grid"><div><span>Document / job</span><strong>{fileName}</strong><small>{jobId}</small></div><div><span>Source</span><strong>{job?.source||'Manual upload'}</strong></div><div><span>Status</span><strong>{statusLabel(job?.status)}</strong></div><div><span>Progress</span><strong>{progress}%</strong></div><div><span>Extraction time</span><strong className={runtime.tone?`runtime runtime-${runtime.tone}`:''}>{runtime.label}</strong></div><div><span>Destination</span><strong>{job?.conga_send_status==='sent'?'Conga ✓':'Not sent'}</strong></div><div><span>Rendered pages</span><strong>{documentPageCount}</strong></div><div><span>Extracted records</span><strong>{records.length}</strong></div></div>
  } {
    config&&<div className="section-total"><span>Total {tab}</span><strong> {
      sectionRecords.length
    }
    </strong><small>extracted items</small></div>
  } {
    tab!=='Overview'&&dataView()
  }
  </aside>
  }
  </div></main>{expandedField&&agreement&&<div
    className="field-popout-overlay"
    role="presentation"
    onMouseDown={()=>setExpandedField(null)}
  ><section
    className="field-popout-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="field-popout-title"
    onMouseDown={event=>event.stopPropagation()}
  ><header><div><span className="kicker">EXPANDED EDITOR</span><h2 id="field-popout-title">{expandedField}</h2></div><button
    type="button"
    className="field-popout-close"
    onClick={()=>setExpandedField(null)}
    aria-label="Close expanded editor"
  >×</button></header>
  <textarea
    className="field-popout-textarea"
    value={display(agreement[expandedField])}
    readOnly={!canEdit}
    onChange={event=>updateRecord(
      agreement,
      expandedField,
      event.target.value
    )}
    autoFocus
  />
  <footer><span>Changes remain synchronized with the extracted value and JSON.</span><button
    type="button"
    className="primary-btn"
    onClick={()=>setExpandedField(null)}
  >Done</button></footer></section></div>}</div>
}
